import { Stack } from "@mui/material";
import useIsCreate from "hooks/useIsCreate";
import BackPageButton from "components/buttons/BackPageButton";
import ROUTES from "constants/routes";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import qs from "qs";
import { useVacancyHeaderQuery } from "@generated/graphql";
import Content from "./components/Content";
import Header from "./components/Header";
import TrialList from "./components/TrialList";

const CandidateView = () => {
  const isCreate = useIsCreate();
  const [searchParams] = useSearchParams();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);
  const { vacancyId } = params as { vacancyId?: string };

  const { data: vacancyHeaderData } = useVacancyHeaderQuery({ variables: { vacancyId: vacancyId! }, skip: !vacancyId });
  const vacancy = vacancyHeaderData?.vacancy;

  const getBackPageButtonProps = () => {
    if (vacancyId) {
      return {
        text: `Вакансия «${vacancy?.title}»`,
        link: `/${ROUTES.VACANCIES}/view/${vacancyId}`,
      };
    }

    return {
      text: "Список кандидатов",
      link: `/${ROUTES.CANDIDATE}`,
    };
  };

  return (
    <>
      <BackPageButton {...getBackPageButtonProps()} />
      <Stack spacing={2.5}>
        <Header />
        <Content />
        {!isCreate && <TrialList />}
      </Stack>
    </>
  );
};

export default CandidateView;
